import Vue from 'vue';
import moment from 'moment'

export default Vue.component('bid-history-who', {
  props: ['log'],
  template: `
    <span>
      <template v-if="getWho(log) === 'Licitátor'">
        <span class="badge badge-primary br-5 m-1">Licitátor</span>
      </template>
      <template v-else>
        {{ getWho(log) }}
      </template>
    </span>
  `,
  data() {
    return {}
  },
  methods: { 
    getWho(log) {
      if (typeof log.who === 'string') {
        return log.who === 'robot' ? 'Licitátor' : log.who
      } else {
        return log.who.contact.code
      }
    },
  }
});
